<template>
  <v-container style="min-height: calc(100vh - 124px);">
    <v-row class="mt-0">
      <v-col cols="12" md="12">
        <v-text-field
          dense
          prepend-inner-icon="search"
          v-model="paramkamus.keyword"
          label="Search"
          name="keyword">
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" class="pt-0" v-if="datasearch.length > 0">
        <router-link
          class="link-list-style"
          v-for="(kamus, i) in datasearch"
          :key="i"
          :to="{ name: 'Kamusdetail', query: { vocab: kamus.id_vocab } }">
          <div
            class="item-list-style py-3">
            <span>{{ kamus.vocab_en }}</span>
          </div>
        </router-link>
      </v-col>
      <v-col cols="12" v-if="datasearch.length <= 0">
        <span class="text--disabled text-caption">Data tidak tersedia</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Kamusfavorite',
  data: () => ({
    selectedItem: 1,
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    datalist: [],
    panduan: null,
    paramkamus: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    this.$store.commit('UPDATE_TITLE', 'Favorites');
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'k_favorite',
    ]),
    datasearch() {
      if (!this.paramkamus.keyword) {
        return this.k_favorite;
      } else {
        const listres = this.k_favorite.filter((list) => {
          const keystr = list.vocab_en !== '' && list.vocab_en !== null && list.vocab_en !== undefined ? list.vocab_en : 'empty';
          return keystr.toLowerCase().includes(this.paramkamus.keyword.toLowerCase());
        });
        return listres;
      }
    },
  },
  methods: {
    getKamusFilter() {
      console.log('');
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;

  .item-list-style{
    border-bottom: solid thin #BDBDBD;
  }
  .item-list-style:hover{
    color: $main-color;
    border-color: $main-color;
  }
  a.link-list-style{
    text-decoration: none;
    color: black;
  }
</style>
